import React from 'react';
import { ChainIcon } from '../ChainIcon';
import { CHAIN_KEYS } from '../../chains/interfaces';
import { getExplorerTxUrl } from '../../chains/registry';

export const TransactionStatus = ({
  status,
  statusType,
  selectedChainKey,
  transactionHash,
  pendingSwapHash,
  pendingSwapClearLabel,
  onClearPendingSwap,
}) => {
  if (!status) return null;

  return (
    <div
      className={`status ${statusType === 'error' ? 'error' : statusType === 'success' ? 'success' : 'info'}`}
      role={statusType === 'error' ? 'alert' : 'status'}
      aria-live={statusType === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <div className="status-content">
        <div className="status-message-row">
          <ChainIcon chainKey={selectedChainKey} size={14} />
          <span>{status}</span>
        </div>
        {(transactionHash || pendingSwapHash) && (
          <div className="status-actions">
            {transactionHash && (
              <a
                href={getExplorerTxUrl(selectedChainKey, transactionHash)}
                target="_blank"
                rel="noopener noreferrer"
                className="etherscan-link"
              >
                View on {selectedChainKey === CHAIN_KEYS.SOLANA ? 'Solana Explorer' : 'Etherscan'}{' '}
                &#8599;
              </a>
            )}
            {pendingSwapHash && (
              <button type="button" className="pending-clear-btn" onClick={onClearPendingSwap}>
                {pendingSwapClearLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
